//@import dependencies
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {Helmet} from 'react-helmet'
import parse from 'html-react-parser';
//@end

//@import components
import {PublicAppLayout} from 'app_components/layouts/public'
import HeaderCourseModule from 'app_components/modules/academic/headercourse'
import DescriptionCourseModule from 'app_components/modules/academic/descriptioncourse'
import BuyCourseModule from 'app_components/modules/academic/buyCourse'
import CourseSkeleton from './courseSkeleton'

//@end

// @import hooks
// @end

// @INFO Import types
import { ICourse } from 'app_types/campus/academic/courseTypes'
// @end

// @INFO Import services
import EditorjsService from 'app_services/components/editorjs/editorjsService';
// @end

// @INFO Import Styles
import './../courseScreen.scss'
import { useLocation, useParams } from 'react-router-dom';
import CourseService from 'app_services/campus/academic/courseService';

// @ADD Component types
interface ICourseScreenLayoutProps {
  status: null | 'loading' | 'error'
  programCourse: ICourse | null
}

const CourseScreenLayout: React.FC<ICourseScreenLayoutProps> = ({
  programCourse,
  status,
}) => {

  const { t } = useTranslation()
  const editorjsService = useMemo(() => new EditorjsService(), [])
  const courseService = useMemo(() => new CourseService(), [])
  const { slug } = useParams<{ slug: string }>()
  const [courses, setCourses] = useState<ICourse[]>([])
  const [currentCourse, setCurrentCourse] = useState<ICourse>()
  const [loading, setLoading] = useState<boolean>(false)
  const { pathname, state } = useLocation<{ courseId: string }>()
  const isProgramSlug = pathname?.includes('/novedad') || (!courses?.length && !loading)
  const isLoading = isProgramSlug ? loading : status === 'loading'
  const courseToRender = isProgramSlug ? programCourse : currentCourse

  const offertIcontec = require('app_assets/images/logos/offert_icontec.png')

  const getDescription = () => {
    let description = null;
    if (courseToRender?.extra_info?.description?.blocks) {
      description = parse(editorjsService.jsonToHtml(courseToRender?.extra_info?.description?.blocks ? courseToRender?.extra_info?.description?.blocks : []))
    } else if (courseToRender?.extra_info?.description) {
      description = courseToRender?.extra_info?.description
    }
    return description;
  }

  const fetchCourses = useCallback(async () => {
    setLoading(true)
    const response = await courseService.fetchCoursesByCourseSlug({
      slug
    })
    if (response?.code === 200) {
      setCourses(response.courses)
    }
    setLoading(false)
  }, [courseService, slug])

  useEffect(() => {
    fetchCourses()
  }, [fetchCourses])

  useEffect(() => {
    if (courses?.length) {
      if (state?.courseId) {
        const course = courses?.find(({ _id }) => _id === state.courseId)
        if (course) {
          setCurrentCourse(course)
        } else {
          setCurrentCourse(courses[0])
        }
      } else {
        setCurrentCourse(courses[0])
      }
    }
  }, [courses])

  return(
    <PublicAppLayout>
      <Helmet>
        <meta name="description" content={getDescription()}></meta>

        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={courseToRender?.program?.name} />
        <meta property="og:description" content={getDescription()} />
        <meta property="og:image" content={courseToRender?.extra_info?.coverUrl} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta property="twitter:domain" content="" />
        <meta property="twitter:url" content={window.location.href} />
        <meta name="twitter:title" content={courseToRender?.program?.name} />
        <meta name="twitter:description" content={getDescription()} />
        <meta name="twitter:image" content={courseToRender?.extra_info?.coverUrl} />
      </Helmet>

      <div className="course_screen-component">
        {isLoading ? (
          <CourseSkeleton />
        ): (
          <>
            <section className="section-header">
              <div
                className='section-header--image'
                style={{ background: `url(${offertIcontec})` }}
              />
              <HeaderCourseModule
                type={'course'}
                course={courseToRender as ICourse}
              />
            </section>
            <section className="section-buy-course">
              <BuyCourseModule
                course={courseToRender as ICourse}
                className='buy-course-custom'
                coursesToRender={courses}
                setCurrentCourse={(newCourse) => setCurrentCourse(newCourse)}
              />
            </section>
            <section className="section-description">
              <DescriptionCourseModule
                course={courseToRender as ICourse}
              />
            </section>
          </>
        )}
      </div>
    </PublicAppLayout>
  )
}

export default CourseScreenLayout
